'use client'

import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokProductCardType } from '../../storyblok'
import { useStoryblokServerSideData } from '../../storyblok-server-side-data/context/storyblokServerSideDataContext'
import { StoryblokProductBatteryItem } from '../StoryblokProductBatteryItem'

import styles from '../StoryblokProductCard/StoryblokProductCard.module.css'

export const StoryblokProductCard: FC<
  StoryblokComponentProps<StoryblokProductCardType>
> = ({ blok }) => {
  const { data, error } = useStoryblokServerSideData(blok)

  if (error || !data) {
    return null
  }

  return (
    <div className={styles['product-card-container']}>
      <StoryblokProductBatteryItem product={data} />
    </div>
  )
}
